var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessCardBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 240.94 155.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{letter-spacing:-.03em;}.cls-2{letter-spacing:0em;}.cls-3{clip-path:url(#clippath-2);}.cls-4{fill:#8ccfb7;}.cls-5,.cls-6{font-size:9px;}.cls-5,.cls-6,.cls-7{font-family:CFArmadilloStd-Medium, 'CF Armadillo Std';font-weight:500;}.cls-5,.cls-7{fill:#082340;}.cls-6,.cls-8{fill:#6dc067;}.cls-9{fill:#fffef9;}.cls-10{clip-path:url(#clippath-1);}.cls-11{letter-spacing:0em;}.cls-12{letter-spacing:-.05em;}.cls-13{letter-spacing:-.03em;}.cls-14{stroke:#8ccfb7;stroke-linecap:round;stroke-linejoin:round;}.cls-14,.cls-15{fill:none;}.cls-16{clip-path:url(#clippath);}.cls-17{letter-spacing:-.08em;}.cls-18{clip-path:url(#clippath-3);}.cls-19{letter-spacing:-.01em;}.cls-7{font-size:8px;}.cls-8{font-family:CFArmadilloStd-Bold, 'CF Armadillo Std';font-size:10px;font-weight:700;}.cls-20{letter-spacing:-.02em;}.cls-21{letter-spacing:-.02em;}.cls-22{fill:#6ec068;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 47.24,
    y: 22.64,
    width: 49.47,
    height: 11.64
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 47.24,
    y: 22.64,
    width: 49.47,
    height: 11.64
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 29.23,
    y: 22.77,
    width: 13.68,
    height: 11.38
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 29.23,
    y: 22.77,
    width: 13.68,
    height: 11.38
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    width: 240.94,
    height: 155.91
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(29.23 53.21)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u039C\u03AC\u03C1"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 18.61,
    y: 0
  }, "\u03BA"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.25,
    y: 0
  }, "\u03BF\u03C2 "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 35.8,
    y: 0
  }, "\u03A3"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.1,
    y: 0
  }, "\u03B1\u03C1\u03AC\u03C6\u03B7\u03C2")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(29.23 66.57)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0394\u03B9\u03B5\u03C5\u03B8\u03CD"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 24.04,
    y: 0
  }, "\u03BD\u03C9"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 33.1,
    y: 0
  }, "\u03BD"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.48,
    y: 0,
    xmlSpace: "preserve"
  }, " \u03C3\u03CD\u03BC\u03B2\u03BF\u03C5\u03BB\u03BF\u03C2")), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(139.6 116.72)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 0,
    y: 0
  }, "\u039B"), /*#__PURE__*/React.createElement("tspan", {
    x: 5.11,
    y: 0
  }, "\u03B5\u03C9\u03C6\u03CC\u03C1\u03BF\u03C2 \u039D\u03AF\u03BA\u03B7\u03C2 3,"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 10.8
  }, "\u0398\u03B5\u03C3\u03C3\u03B1\u03BB"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 30.22,
    y: 10.8
  }, "\u03BF"), /*#__PURE__*/React.createElement("tspan", {
    x: 35.02,
    y: 10.8
  }, "\u03BD\u03AF\u03BA\u03B7")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(29.23 100.26)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u039A. "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 8.41,
    y: 0
  }, "697"), /*#__PURE__*/React.createElement("tspan", {
    x: 22.16,
    y: 0
  }, "9 893 9"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 50.4,
    y: 0
  }, "4"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 54.98,
    y: 0
  }, "9")), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(29.23 116.72)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "sarafis.m@capio.com")), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 123.73,
    y1: 90.39,
    x2: 123.73,
    y2: 140.17
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(139.6 100.26)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u03A4. "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 8,
    y: 0
  }, "23"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 17.17,
    y: 0
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 21.35,
    y: 0
  }, "0 "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 28.42,
    y: 0
  }, "3"), /*#__PURE__*/React.createElement("tspan", {
    x: 33,
    y: 0
  }, "2 "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 40.06,
    y: 0
  }, "3"), /*#__PURE__*/React.createElement("tspan", {
    x: 44.65,
    y: 0
  }, "2 "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 51.71,
    y: 0
  }, "3"), /*#__PURE__*/React.createElement("tspan", {
    x: 56.3,
    y: 0
  }, "2 ")), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(29.23 127.87)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "www.capio.com")), /*#__PURE__*/React.createElement("g", {
    id: "capio_simple"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m82.75,24.4c0-.43.13-.8.39-1.11.35-.41.87-.62,1.41-.62h10.43c.47,0,.88.17,1.22.5.34.33.51.74.51,1.23v8.15c0,.49-.17.9-.51,1.23-.34.33-.75.5-1.22.5h-10.43c-.54,0-1.06-.21-1.41-.62-.26-.31-.39-.68-.39-1.11v-8.15Zm12.3,8.3v-8.45s-.02-.04-.04-.04h-10.18c-.23,0-.42.19-.42.42v7.7c0,.23.19.42.42.42h10.18s.04-.02.04-.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m54.23,34.28h-5.26c-.47,0-.88-.17-1.22-.5-.34-.33-.51-.75-.51-1.23v-8.17c0-.49.17-.9.51-1.23.34-.33.75-.5,1.22-.5h5.26v1.54h-5.33v8.55h5.33v1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m62.81,23.14c-.34-.33-.75-.5-1.22-.5h-5.26v1.54h5.33v2.97h-7.74c-.47,0-.88.17-1.22.5-.34.33-.51.75-.51,1.23v3.66c0,.49.17.9.51,1.23.34.33.75.5,1.22.5h7.67c.48,0,.88-.17,1.22-.5.34-.33.51-.74.51-1.23v-8.17c0-.49-.17-.9-.51-1.23m-1.15,9.59h-7.81v-4.04h7.81v4.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m81.47,34.28h-1.58v-7.57c-.91,0-1.82,0-2.73,0v-2.52h-10.9v4.51h10.9v-.53h1.66c.02.33,0,.58-.03.7-.03.17-.09.3-.09.3-.03.06-.13.31-.37.56-.04.04-.07.07-.11.1-.31.27-.69.41-1.12.41h-10.82v4.04h-1.66v-9.9c0-.49.17-.9.51-1.24.34-.33.75-.5,1.23-.5h10.75c.48,0,.88.17,1.23.5.34.33.51.75.51,1.24v.67h2.63c0,2.99.01,6.24.02,9.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m80.63,22.64h0c.46,0,.83.37.83.83v.26c0,.46-.37.83-.83.83s-.83-.37-.83-.83v-.26c0-.46.37-.83.83-.83"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "capio_icon"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m29.23,24.47c0-.42.13-.78.38-1.09.34-.4.85-.61,1.38-.61h10.22c.46,0,.86.16,1.2.49.33.33.5.73.5,1.21v7.99c0,.48-.17.88-.5,1.21-.33.33-.73.49-1.2.49h-10.22c-.53,0-1.04-.21-1.38-.61-.26-.3-.38-.66-.38-1.08v-7.99Zm12.05,8.13v-8.28s-.02-.04-.04-.04h-9.98c-.23,0-.41.18-.41.41v7.55c0,.23.18.41.41.41h9.98s.04-.02.04-.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m37.8,27.23c0-.15.05-.27.15-.37.1-.1.23-.15.37-.15h3.17c.14,0,.27.05.37.15.1.1.15.22.15.37v2.46c0,.15-.05.27-.15.37-.1.1-.23.15-.37.15h-3.17c-.14,0-.27-.05-.37-.15-.1-.1-.15-.22-.15-.37v-2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m35.8,28.46c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessCardBack);
export default __webpack_public_path__ + "static/media/business-card-back.1094629f3be3606719fadf8511d6cb60.svg";
export { ForwardRef as ReactComponent };